import * as components from './components';

export default [
    {
        path: '/reports/costco',
        component: components.Costco,
        name: 'costcoreport',
        meta: { admin: true }
    },
    {
        path: '/reports/claims',
        component: components.ClaimHistory,
        name: 'claimreport',
        meta: { admin: true }
    },
    {
        path: '/reports/parts',
        component: components.PriceList,
        name: 'partsreport'
    },
    {
        path: '/reports/resolutioncodes',
        component: components.ResolutionCodeList,
        name: 'resolutioncodesreport'
    },
    {
        path: '/reports/usedparts',
        component: components.UsedPartsList,
        name: 'usedpartsreport'
    },
    {
        path: '/reports/graphs',
        component: components.Graphs,
        name: 'graphs',
        meta: { admin: true }

    },
    {
        path: '/reports/serviceTickets',
        component: components.ServiceTickets,
        name: 'servicetickets',
        meta: { admin: true }
    },
    {
        path: '/reports/rma',
        component: components.RMA,
        name: 'reports_rma',
        meta: { admin: true }
    },
    {
        path: '/reports/simsApReport',
        component: components.ApReport,
        name: 'simsapreport',
        meta: { admin: true }
    }
];


// WEBPACK FOOTER //
// ./ClientApp/app/reports/routes.js